/// <amd-module name="Repos/Views/Import/RestClient/ServiceEndpoint" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\import\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as ServiceEndpoint from "Repos/Views/Import/Contracts/ServiceEndpoint";

export interface IServiceEndpointRestClient extends IVssRestClient {
    /**
     * Create a service endpoint.
     * 
     * @param endpoint - Service endpoint to create.
     * @param project - Project ID or project name
     */
    createServiceEndpoint(endpoint: ServiceEndpoint.ServiceEndpoint, project: string): Promise<ServiceEndpoint.ServiceEndpoint>;
}

class ServiceEndpointRestClient extends RestClientBase implements IServiceEndpointRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a service endpoint.
     * 
     * @param endpoint - Service endpoint to create.
     * @param project - Project ID or project name
     */
    public async createServiceEndpoint(
        endpoint: ServiceEndpoint.ServiceEndpoint,
        project: string
        ): Promise<ServiceEndpoint.ServiceEndpoint> {

        return this.beginRequest<ServiceEndpoint.ServiceEndpoint>({
            apiVersion: "5.0-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/serviceendpoint/endpoints/{endpointId}",
            routeValues: {
                project: project
            },
            body: endpoint
        });
    }

}

export const ServiceEndpointClientName = "Repos.Import.ServiceEndpoint.IServiceEndpointRestClient";

export function getServiceEndpointClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IServiceEndpointRestClient {
    return pageContext.getRestClient<IServiceEndpointRestClient>(ServiceEndpointClientName, options);
}

RestClients.add(ServiceEndpointClientName, { 
    factory: ServiceEndpointRestClient,
    options: {
        resourceAreaId: "1814ab31-2f4f-4a9f-8761-f4d77dc5a5d7",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
